import script from "./UserCreateAccessData.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreateAccessData.vue?vue&type=script&setup=true&lang=js"

import "./UserCreateAccessData.vue?vue&type=style&index=0&id=e192327e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e192327e"]])

export default __exports__